import { render, staticRenderFns } from "./vacancy.vue?vue&type=template&id=0662fc71&scoped=true"
import script from "./vacancy.vue?vue&type=script&lang=js"
export * from "./vacancy.vue?vue&type=script&lang=js"
import style0 from "./vacancy.vue?vue&type=style&index=0&id=0662fc71&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0662fc71",
  null
  
)

export default component.exports